import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["output"];

  connect() {
    this.resizeText();
  }

  resizeText() {
    if (!this.hasOutputTarget) return;

    const measurementText = this.outputTarget.textContent.trim();
    const charLimit = 3;
    const filteredText = measurementText.replace(/\./g, "");

    if (filteredText.length > charLimit) {
      this.outputTarget.style.fontSize = "1rem";
    } else {
      this.outputTarget.style.fontSize = "1.5rem";
    }
  }
}
